import { Heading, Text } from '@chakra-ui/react';
import React from 'react';

import PageContainer from '../../components/pageContainer/PageContainer';

function PaymentSuccess() {
  return (
    <PageContainer>
      <Heading>An error occured while processing the payment</Heading>
      <Text>Please contact our team to resolve any issues</Text>
    </PageContainer>
  );
}

export default PaymentSuccess;
